module.exports = __webpack_public_path__ + "img/month_9_icon.b07999de.png";